import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
import MediaQuery from 'marketplace-ui-common/layout/components/MediaQuery';
import { getThemeEventSelectorId } from '../../utils/hsAnalytics';
import { getPublicDetailPageFullUrl } from '../../utils/urls';
import { useOfferingType } from '../../context/OfferingTypeContext';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
export default function AssetShareButton(_ref) {
  let {
    responsive,
    section,
    slug: passedSlug
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["responsive", "section", "slug"]);

  const {
    slug
  } = useParams();
  const shareSlug = passedSlug || slug;
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const lang = getLang();
  const offeringType = useOfferingType();
  const {
    isMobileView
  } = useResponsiveProps({
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.MD]: false
    }
  });
  const computedShareUrl = useMemo(() => {
    return getPublicDetailPageFullUrl(lang, offeringType, shareSlug);
  }, [lang, offeringType, shareSlug]);
  return /*#__PURE__*/_jsxs(UICopyButton, Object.assign({}, rest, {
    onClick: () => trackInteraction('click share link', {
      section
    }),
    "data-hs-analytics-id": getThemeEventSelectorId('SHARE'),
    value: computedShareUrl,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "share",
      size: responsive && isMobileView ? 'xs' : undefined
    }), /*#__PURE__*/_jsx(MediaQuery, {
      minScreenSize: responsive ? ScreenSizes.MD : ScreenSizes.XS,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.details.share"
      })
    })]
  }));
}